import React from 'react';
import './Footer.css';

class Footer extends React.Component {
    render() {
        return (
            <footer>
              <p className="copyright">
                  Copyright &copy; UshinohiProject All Rights Reserved.
              </p>
            </footer>
        );
    }
}

export default Footer